var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { pageImages } from '@/pages/images';
import { Typography } from '@mui/material';
import { FeedbackInput } from '@/components/results-category/components/feedback/feedback-input.component';
import { SideImageLayout } from 'hx-ui';
import { FeedbackNavigation } from '@/components/results-category/components/feedback/feedback-navigation.component';
import { useForm } from 'react-hook-form';
export function Feedback() {
    var heading = "We'd love to hear your feedback";
    var form = useForm({
        mode: 'onSubmit',
    });
    return (_jsx(SideImageLayout, { className: 'px-5 md:px-0', imageLeft: pageImages.menSmiling, leftPanelWidth: "40%", headingComponent: _jsx(Typography, __assign({ align: 'center', className: 'text-white text-2xl' }, { children: _jsx("strong", __assign({ className: "block" }, { children: heading })) })), header: _jsx("div", __assign({ className: "w-full flex flex-col justify-center gap-6 pt-6 md:hidden" }, { children: _jsx("span", __assign({ className: "font-extrabold leading-10 text-3xl text-center" }, { children: heading })) })), content: _jsx(FeedbackInput, { form: form }), nav: _jsx(FeedbackNavigation, { isSubmitSuccessful: form.formState.isSubmitSuccessful }) }));
}
